var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    width: 51,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1574-767h1920v2176h-1920z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 51,
    height: 51,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAAAAXNSR0IB2cksfwAAAO1QTFRFzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4M7L68/Pv8+fLz1E1F6bKw9N7ezh4Mzh4M0Tgt7snI119Yzh4M2m9q3X568dTT5qakzh4M9+jozh4Mzh4M45mWzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4M4IyJzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4Mzh4MNJIcEQAAAE90Uk5TAAhCfqjO5fD/CVu19xCA6wJn7e4lyVXxd/6Mi3hXKPXKA2j///////9uD////3n/////6v9Wsv+zrdDR6fny/4ERaW/LWH3vgly3+EN/RP14IA4AAAI8SURBVHicnZZpQ8IwDIbLRCwKAwXBWwQGU5gcgooneN///+fYrunWrtlE3k9rlmdLk/QgxFDKWkovZ1boSmY5vWSlTIeosqtrOaoqt7aaTSTydoGaKtj5WKK4voEQXKX1Io6UN2MIrs0yhlSqCQil1YqJbG0nIpRub0WRnT8Irl0d2ZsDoXRPRfb/CgzCU+Z0cDgXwhIRZK+YlGRdtSNg6oGp0fTltAJLW1hcOT4WyElY/Y4jXLrS4Ilx05OG0onPnCr/7oFPH8YDMRyGHqccSZ2pAUMso44/6kciYyrwxVHRJtkZKV+WA0/1GDPmXM+MnAFPw1A8XmgOlyw0fYkFjgNKW8GTqlyWWDQqV6ahG028kEVsg/FEwp0+FhmTTSYGQy+aigbG6wm5MhlZFTQySq/JDcK0nIDpm28z5BZhZC2VJlJ0RzBE5puF1kHeov/xwvkgP7pD5+MqeTNSzeaD5E1E5oxiEneN1Aciu+/FFGiC9IEr+7+LR2eb/QYrqBeWydMdLKOvIaIGf4YmcjUH1tfkUrPAMoO6QAKHqgdbP2SMRTbUfqpFx9dpSj2mwGkkx7B5uWE7+PsBmRqR8QSAAdLQDlym/l41C/e3ttEwci3Jr5RmYlN8kA6tgZBa+q4wNWD4+P/9+knu14ucC4Q8z3n+jNVD62UuRjvnFjpPFzq3F7ofsHtILQGpofcQVqd6KYZ4rcfcd5jyU/Re9TaLJbiy7x/6Ivz8eE++vwns65vdE6u0yu6J3z8I8AtbUYNG2iTp7gAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-x.41445e9a9949c48f30d0d31adee95bbd.svg";
export { ForwardRef as ReactComponent };